export const ORDER_FULFILLMENT_PIPELINE = [
  "pending",
  "paid",
  "confirmed",
  "processing",
  "shipped",
  "delivered",
];

export const ORDER_STATUS_META = {
  pending: { label: "Awaiting Payment", color: "yellow" },
  paid: { label: "Payment Confirmed", color: "green" },
  confirmed: { label: "Confirmed", color: "blue" },
  processing: { label: "Processing", color: "indigo" },
  shipped: { label: "Shipped", color: "purple" },
  delivered: { label: "Delivered", color: "green" },
  cancelled: { label: "Cancelled", color: "red" },
  refunded: { label: "Refunded", color: "gray" },
  failed: { label: "Failed", color: "red" },
};

export const TERMINAL_ORDER_STATUSES = ["cancelled", "refunded", "failed"];

export function normalizeOrderStatus(status) {
  return status;
}

export function getOrderStatusLabel(status) {
  const normalized = normalizeOrderStatus(status);
  return (
    ORDER_STATUS_META[normalized]?.label ||
    ORDER_STATUS_META[status]?.label ||
    (status
      ? status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ")
      : "Unknown")
  );
}

export function getOrderStatusColor(status) {
  const normalized = normalizeOrderStatus(status);
  return (
    ORDER_STATUS_META[normalized]?.color ||
    ORDER_STATUS_META[status]?.color ||
    "gray"
  );
}

export function getOrderStatusProgress(status) {
  if (TERMINAL_ORDER_STATUSES.includes(status)) return 0;

  const normalized = normalizeOrderStatus(status);
  const index = ORDER_FULFILLMENT_PIPELINE.indexOf(normalized);
  if (index < 0) return 0;

  return ((index + 1) / ORDER_FULFILLMENT_PIPELINE.length) * 100;
}

export function isOrderStatusComplete(stepStatus, currentStatus) {
  const normalizedCurrent = normalizeOrderStatus(currentStatus);
  const currentIndex = ORDER_FULFILLMENT_PIPELINE.indexOf(normalizedCurrent);
  const stepIndex = ORDER_FULFILLMENT_PIPELINE.indexOf(stepStatus);
  if (currentIndex < 0 || stepIndex < 0) return false;
  return stepIndex <= currentIndex;
}
